import React, { FC } from 'react'
import { Grid } from '@mui/material'
import { DetailHeader } from '../detail-header'
import { DetailItem } from '../detail-item'

export const Features: FC = () => {

	return (
		<Grid container>
			<DetailHeader headerText='Características' />
			<DetailItem
				mainText='Tasa anual referencial'
				tooltipText='Tasa de interés inicial reajustable trimestralmente de acuerdo con requerido por la normativa del Banco Central.'
				variant="bodyText"
				weightColorSecondary='500'
				secontaryText='15,60%'
			/>
			<hr className='separador' />
			<DetailItem
				mainText='Sistema de amortización'
				tooltipText='Pagos periódicos iguales. Amortización de capital creciente e interés decreciente. Si necesitas condiciones diferentes a las presentadas, por favor acércate a agencia.'
				variant="bodyText"
				weightColorSecondary='500'
				secontaryText='Francesa'
			/>
		</Grid>
	);


}
